import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import React, { ChangeEvent, useCallback } from 'react';
import { Grid } from '@mui/material';
import { DealTypes, DiscountTypes } from 'api';
import DEALS from 'constants/deals';
import { arrayToOptions } from 'helpers/common';
import { FormCard, FormInput } from 'components';

interface Props {
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  watch: UseFormWatch<DiscountTypes.ItemCreateParams>;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
}

const ChannelBlock = (props: Props): JSX.Element | null => {
  const { control, watch, setValue } = props;

  const strategy = watch('strategy');

  const handleStrategyChange = useCallback(
    (
      event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      onChange: (value: string | string[] | undefined) => void,
    ) => {
      const value = event.target.value as DealTypes.StrategiesEnum;
      const channelOptions = DEALS.CHANNEL_OPTIONS[value];

      setValue('channel', channelOptions[0]);

      onChange(value);
    },
    [setValue],
  );

  return (
    <FormCard title="Additional information">
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormInput
            control={control}
            name="strategy"
            inputType="select"
            label="Channel"
            tooltip="After changing the channel, subchannel field value will be changed to first item in subchannels list"
            options={DEALS.STRATEGY_OPTIONS}
            onChange={handleStrategyChange}
            rules={{
              required: true,
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FormInput
            control={control}
            name="channel"
            inputType="select"
            label="Sub channel"
            options={
              strategy
                ? arrayToOptions(DEALS.CHANNEL_OPTIONS[strategy])
                : DEALS.SUB_CHANNEL_OPTIONS
            }
            rules={{
              required: true,
            }}
          />
        </Grid>
      </Grid>
    </FormCard>
  );
};

export default ChannelBlock;
